import axios from 'axios';
import { BASE_URL } from 'app/services/auth-services';

const API_ENDPOINTS = {
  Leave: '/Felix/Getleave/',
  'Leave Cancellation': '/Felix/LeavecancellationwithouttokenCRUD/',
  timesheet: '/Felix/TimeSheetwithoutCRUD/',
  Reimbursement: '/Felix/EmployeeClaimGetById/',
  'Full and Final Settlement': '/Felix/FullandFinalCRUD/',
  Resignation: '/Felix/EmployeeResignationGet/',
  'Attandance Management': '/Felix/Attandancemasterget/',
  'payroll management': '/Felix/PayslipwithoutCRUD/',
};

export const fetchDocumentData = async (workflowName, id) => {
  try {
    if (workflowName === 'Attandance Management' || workflowName === 'payroll management') {
      return await fetchMultipleDocuments(workflowName, id);
    }

    const endpoint = API_ENDPOINTS[workflowName];
    if (!endpoint) throw new Error(`Unknown workflow: ${workflowName}`);

    const response = await axios.get(`${BASE_URL}${endpoint}?id=${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${workflowName} data:`, error);
    throw error;
  }
};

const fetchMultipleDocuments = async (workflowName, id) => {
  const idArray = JSON.parse(id.replace(/'/g, '"'));
  const endpoint = API_ENDPOINTS[workflowName];

  const promises = idArray.map(idValue =>
    workflowName === 'Attandance Management'
      ? axios.post(`${BASE_URL}${endpoint}`, { id: idValue })
      : axios.get(`${BASE_URL}${endpoint}?id=${idValue}`)
  );

  const responses = await Promise.all(promises);
  return responses.map(res => res.data);
};

export const fetchLeaveApprovalWorkflow = async (id) => {
  try {
    const response = await axios.post(`${BASE_URL}/Felix/LeaveApprovalWorkflow/`, {
      Employee_Id: String(id),
    });
    return response?.data || {};
  } catch (error) {
    console.error('Error fetching LeaveApprovalWorkflow:', error);
    throw error;
  }
};